import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Input, Icon, CheckBox } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, Dimensions, View } from 'react-native';
import * as RootNavigation from '../../../root.navigation.js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import trackerApi from '../../api/tracker';
import { showMessage, hideMessage } from "react-native-flash-message";

import {useSelector, useDispatch} from 'react-redux';
const reasons = [
  'مشتری پاسخگو نمی‌باشد.',
  'کنسل کردن از طرف مشتری',
  'با تماس تلفنی مشکل برطرف شد'
]
const CallIcon = (props) => (
  <Icon {...props}  name='phone-call'/>
);

const BookmarkIcon = (props) => (
  <Icon {...props}  name='bookmark'/>
);

const  width= Dimensions.get('window').width-40
export const ServiceInfo = ({ navigation }) => {
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [description, setDescription] = useState('');
  const data = useSelector( state => state.request.data);

  const finishTask = async() =>{
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/invoice/cancel_invoice',
      {
        description,
        reason: checked1 ? reasons[0] : checked2 ? reasons[1]: checked3? reasons[2] : null,
        request_id: data.id,
      } ,
      {
        headers: {Authorization: `Bearer ${token}`}
      });
    if(response.data.status) {
      console.log('data saved!');
      showMessage({
        message: `ثبت شد`,
        type: "success",
      });
      RootNavigation.navigate('Menu')
    }
    else showMessage({
      message: `لطفا اقدامات را تکمیل فرمایید`,
      type: "danger",
    });
  }
  return (
    <View style={{justifyContent:'space-between', alignItems:'center', flex:1}}>
        <Image source = {require('../../../assets/noAddress.png')} style={{width: width , height: width/1.69, marginTop:25}} />
        <View style={{paddingHorizontal:20}}>
          <Text category='c1' appearance='hint' style={{textAlign:'center'}}>تکنسین محترم، لطفا پس از تماس و هماهنگی با مشتری، اقدام به پذیرش نمایید در غیر این صورت نسبت به تکمیل موارد زیر اقدام نمایید.</Text>
        </View>
        <View style={{alignItems:'flex-start', width}}>
        <CheckBox
          style={{marginVertical:10}}
          checked={checked1}
          onChange={nextChecked => {
            setChecked1(nextChecked);
            setChecked2(false);
            setChecked3(false);
          }}>
          <Text>
            {reasons[0]}
          </Text>
        </CheckBox>

        <CheckBox
          style={{marginBottom:10}}
          checked={checked2}
          onChange={nextChecked => {
            setChecked1(false);
            setChecked2(nextChecked);
            setChecked3(false);
          }}>
          <Text>
            {reasons[1]}
          </Text>
        </CheckBox>
        <CheckBox
          style={{marginBottom:10}}
          checked={checked3}
          onChange={nextChecked => {
            setChecked1(false);
            setChecked2(false);
            setChecked3(nextChecked);
          }}>
          <Text>
            {reasons[2]}
          </Text>
        </CheckBox>
        <Input
          placeholder ='توضیحات'
          value={description}
          style={{width}}
          accessoryLeft= {BookmarkIcon}
          multiline={true}
          onChangeText = {newValue =>{ setDescription(newValue); if(description.length>5) setDisabled(false); else setDisabled(true)}}
          />
          <View style={{flexDirection:'row', width, marginTop:15, marginBottom:30}}>
          <Button style={{flex:1,marginHorizontal:5}}
            appearance='outline'
            onPress={()=>{
                RootNavigation.navigate('Menu')
            }}
            >
            بازگشت
          </Button>
          <Button style={{flex:2, marginHorizontal:5}} disabled={disabled} onPress={finishTask}>
            ثبت
          </Button>
          </View>
        </View>

    </View>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    justifyContent:'space-around',
    alignItems:'center'
  },
  box:{
    borderRadius:10,
    width:width-10,
    marginHorizontal:10,
    marginVertical:5,
    padding:10
  }
});
